export const linearProgress = {
    bandWidth: 30,
    progress: {
        style: {
            fillOpacity: 1
        }
    },
    track: {
        style: {
            fill: {
                type: "palette",
                key: "linearProgressTrackColor"
            },
            fillOpacity: 1
        }
    }
};
//# sourceMappingURL=linear-progress.js.map
